import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['overwrite', 'loose'];

  connect() {
    this.toggle();
  }

  toggle() {
    this.looseTarget.disabled = !this.overwriteTarget.checked;
    if (this.looseTarget.disabled) this.looseTarget.checked = false;
  }
}
